export default "__VITE_ASSET__051c863c__"